import { IFormViewForm } from 'components/FormView';

export const getProductReceiptDetailForm = (
  CommentEnabled: any
): IFormViewForm => {
  const form: any = {
    id: 'PurchaseOrderDetails',
    layout: {
      rows: 1,
      columns: 1,
    },
    fields: [
      {
        id: 1,
        position: {
          row: 1,
          col: 1,
        },
        type: 'PAPER_CONTAINER',
        visible: true,
        props: {
          fullWidth: true,
          style: {
            height: 300,
          },
        },
        children: [
          {
            id: 1,
            type: 'EX_LOOKUP_FIELD',
            props: {
              label: 'Tax class',
              name: 'TaxClass',
              required: true,
              size: 'small',
              lookupName: 'TaxClass',
            },
          },
          // We'll conditionally add the comment field below
        ],
      },
    ],
  };

  if (CommentEnabled) {
    form.fields[0].children?.push({
      id: 2,
      type: 'TEXT_AREA',
      props: {
        label: 'Comment',
        name: 'Comment',
        fullWidth: true,
        style: {
          height: 220,
        },
      },
    });
  }

  return form;
};
